<template>
  <div class="content-wrap">
    <div class="detail-title-wrap">
      {{ workInfo.projectName }}
    </div>
    <div class="map-wrap">
      <task-map
        :center="[114.758903, 25.678119]"
        :path="path"
      />
    </div>

    <div class="main-content-wrap">
      <div class="content-main">
        <div class="sender-deliver">
          <div class="sad-wrap">
            <span
              class="sad-suffix"
              style="background-color: #3f8e71"
            >发</span>
            <div class="sad-content">
              <div class="sad-content-name">
                赣州市永固高新材料有限公司
              </div>
              <div class="sad-content-address">
                发货时间：{{ workInfo.createTime | formatTime }}
              </div>
            </div>
          </div>
          <div class="sad-wrap">
            <span
              class="sad-suffix"
              style="background-color: #e26454"
            >收</span>
            <div class="sad-content">
              <div class="sad-content-name">
                {{ workInfo.customer }}
              </div>
              <div
                v-if="workInfo.arriveTime"
                class="sad-content-address"
              >
                送达时间：{{ workInfo.arriveTime | formatTime }}
              </div>
              <div
                v-else
                class="sad-content-address"
              >
                未到达
              </div>
            </div>
          </div>
        </div>
        <div class="info-card-wrap">
          <div class="info-item">
            <div class="item-label">
              任务单号：
            </div>
            <div class="item-content">
              {{ workInfo.singleNo }}
            </div>
          </div>
          <div class="info-item">
            <div class="item-label">
              工程名称：
            </div>
            <div class="item-content">
              {{ workInfo.projectName }}
            </div>
          </div>
          <div class="info-item">
            <div class="item-label">
              施工部位：
            </div>
            <div class="item-content">
              {{ workInfo.consPos }}
            </div>
          </div>
          <div class="info-item">
            <div class="item-label">
              施工地址：
            </div>
            <div class="item-content">
              {{ workInfo.projectAddr || "未填写" }}
            </div>
          </div>
        </div>

        <div
          class="product-info-tag"
          style="margin-top: 0; border-top: solid 1px #f8f8f8"
        >
          <van-tag
            v-if="workInfo.betLev"
            size="medium"
            color="#ffe1e1"
            text-color="#ad0000"
          >
            强度等级：{{ workInfo.betLev }}
          </van-tag>
          <van-tag
            v-if="workInfo.filter"
            size="medium"
            color="#ffe1e1"
            text-color="#ad0000"
          >
            抗滲等级：{{ workInfo.filter }}
          </van-tag>
          <van-tag
            v-if="workInfo.freeze"
            size="medium"
            color="#ffe1e1"
            text-color="#ad0000"
          >
            抗冻等级：{{ workInfo.freeze }}
          </van-tag>
          <van-tag
            v-if="workInfo.lands"
            size="medium"
            color="#ffe1e1"
            text-color="#ad0000"
          >
            塌落度：{{ workInfo.lands }}
          </van-tag>
        </div>
        <div>
          <div class="model-title">
            运输信息
          </div>
          <div class="info-card-wrap show-bottom-line">
            <div class="info-item">
              <div class="item-label">
                发货人：
              </div>
              <div class="item-content">
                赣州市永固高新材料有限公司
              </div>
            </div>
            <div class="info-item">
              <div class="item-label">
                发货时间：
              </div>
              <div class="item-content">
                {{ workInfo.createTime | formatTime }}
              </div>
            </div>
            <div class="info-item">
              <div class="item-label">
                运输车号：
              </div>
              <div class="item-content">
                {{ workInfo.vehicleNo }}
              </div>
            </div>
            <div class="info-item">
              <div class="item-label">
                运输距离：
              </div>
              <div class="item-content">
                {{ workInfo.distance }} KM
              </div>
            </div>
            <div class="info-item">
              <div class="item-label">
                驾驶员：
              </div>
              <div class="item-content">
                {{ workInfo.driverName }}
              </div>
            </div>
            <div class="info-item">
              <div class="item-label">
                到达时间：
              </div>
              <div class="item-content">
                {{ workInfo.arriveTime | formatTime }}
              </div>
            </div>
            <div class="info-item">
              <div class="item-label">
                签收人：
              </div>
              <div class="item-content">
                {{ workInfo.signee }}
              </div>
            </div>
          </div>
          <!-- <div class="info-card-wrap">
            <div class="info-item">
              <div class="item-label">本车方量：</div>
              <div class="item-content">{{ workInfo.square || 0 }}㎥</div>
            </div>
            <div class="info-item">
              <div class="item-label">累计方量：</div>
              <div class="item-content">{{ workInfo.totalSquare || 0 }}㎥</div>
            </div>
            <div class="info-item">
              <div class="item-label">累计车次：</div>
              <div class="item-content">
                {{ workInfo.totVehs || 1 }}
              </div>
            </div>
          </div> -->
        </div>
        <div v-if="showConfirm">
          <div>
            <van-cell-group>
              <van-field
                v-model="delivery"
                label="签收人"
                placeholder="请输入"
                required
                :rules="[{ required: true, message: '请输入名称' }]"
              />
            </van-cell-group>
          </div>

          <div>
            <div class="model-title">
              <span>确认签名</span>
              <span
                style="float: right; font-weight: 400; color: #ff0000"
                @click="draw.clear()"
              >重写签名</span>
            </div>
            <div class="sign-canvas-wrap">
              <canvas
                id="canvas"
                ref="canvas"
                :width="canvasW"
                height="200"
                class="sign-canvas"
              />
            </div>
          </div>
          <div style="padding: 12px">
            <van-button
              block
              type="primary"
              @click="confirm"
            >
              确认签收
            </van-button>
          </div>
        </div>
        <div
          v-else
          style="margin-bottom: 12px"
        >
          <div v-if="workInfo.signUrl">
            <div class="model-title">
              接收签名
            </div>
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                :src="workInfo.signUrl"
                style="width: 350px; height: 200px"
              >
            </div>
          </div>
          <div v-else>
            <div class="model-title">
              接收签名
            </div>
            <div style="padding: 24px; background: #fff; text-align: center">
              此单据尚未签收
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mapPreview from "@/assets/map-preview.jpg";
import Draw from "./draw";
import taskMap from "./task-map.vue";

import {
  findRecordAndTrackBySingleNo,
  confirmSignRecipt,
} from "@/api/ship-record";
import { upload } from "@/api/oss.js";
import { base64ToBlob } from "@/utils";

import dayjs from "dayjs";

export default {
  filters: {
    formatTime(time) {
      if (!time) return time;
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  components: {
    taskMap,
  },
  data: () => ({
    mapPreview,
    workInfo: {},
    canvasMoveUse: false,
    ctx: null,
    canvas: null,
    draw: null,
    delivery: "",
    path: [],
  }),
  computed: {
    canvasW() {
      return window.innerWidth - 26;
    },
    showConfirm() {
      const { type } = this.$route.query;
      if (this.workInfo?.status !== 3) return false;
      if (type === "sm") return true;
      return false;
    },
  },
  watch: {
    path(nwePath) {
      console.log(nwePath);
    },
    showConfirm(prewValue) {
      if (prewValue) {
        setTimeout(() => {
          this.draw = new Draw("canvas");
          this.draw.init();
        }, 200);
      }
    },
  },
  created() {
    this.getShipRecordDetail();
  },
  mounted() {
    if (this.showConfirm) {
      this.draw = new Draw("canvas");
      this.draw.init();
    }
  },
  methods: {
    handleClickLeft() {
      this.$router.go(-1);
    },
    async getShipRecordDetail() {
      const { id, singleNo } = this.$route.query;
      const { data } = await findRecordAndTrackBySingleNo(singleNo ?? id);
      const { moveTrackList, ...workInfo } = data.data;
      this.workInfo = workInfo;
      this.setPath(moveTrackList);
    },
    async confirm() {
      const file = base64ToBlob(this.draw.save());
      const url = await upload(file, "delivery.png").then(({ data }) => {
        console.log("data", data);
        return data.data.url;
      });

      const payload = {
        id: this.workInfo.id,
        signee: this.delivery,
        signUrl: url,
      };

      confirmSignRecipt(payload).then(({ data }) => {
        this.$toast("签收成功");
        this.getShipRecordDetail();
      });
    },
    setPath(pathList) {
      this.path = pathList.reduce((prev, curr) => {
        const { longitude, latitude, type } = curr;
        if (!type || type === "gcj02") {
          prev.push([longitude, latitude]);
        }
        return prev;
      }, []);
    },
  },
};
</script>
<style lang="scss" scoped>
.map-wrap {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
}

.content-wrap {
  position: relative;
  .detail-title-wrap {
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
    padding: 12px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    z-index: 100;
  }

  .map-preview {
    width: 100%;
  }

  .main-content-wrap {
    .content-main {
      /* background-color: #ffffff; */

      > div:not(:first-child) {
        margin-top: 12px;
      }
    }
  }
}

.sender-deliver {
  background: #fff;
  padding: 12px;
  .sad-wrap {
    display: flex;

    + .sad-wrap {
      margin-top: 12px;
      border-top: solid 1px #f8f8f8;
      padding-top: 12px;
    }

    .sad-suffix {
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 30px;
      color: #fff;
      font-size: 12px;
      margin-right: 12px;
    }

    .sad-content {
      .sad-content-name {
      }
      .sad-content-address {
        font-size: 12px;
        color: gray;
      }
    }
  }
}

.product-info-tag {
  background: #ffffff;
  padding: 12px;

  > span {
    + span {
      margin-left: 12px;
    }
  }
}

.sign-canvas-wrap {
  padding: 12px;
  background: #fff;
  .sign-canvas {
    border: solid 1px lightgray;
  }
}

// OLD -vvvvvvvvv-
.detail-title {
  text-align: center;
}

.model-title {
  padding: 6px 12px;
  font-size: 16px;
  font-weight: bold;
}
.info-card-wrap {
  position: relative;
  box-sizing: border-box;
  padding: 12px;
  background-color: #ffffff;

  &.show-bottom-line {
    border-bottom: solid 1px #e8e8e8;
  }
  &.show-color-bar::before {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 2px;
    background: repeating-linear-gradient(
      -45deg,
      #ff6c6c 0,
      #ff6c6c 20%,
      transparent 0,
      transparent 25%,
      #1989fa 0,
      #1989fa 45%,
      transparent 0,
      transparent 50%
    );
    background-size: 21.33333vw;
    content: "";
  }
}

.info-item {
  display: flex;

  + .info-item {
    margin-top: 4px;
  }
  .item-label {
    width: 6em;
  }
  .item-content {
    flex: 1;
  }
}
</style>